var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_4917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.125C0 5.15781 5.45781 0 12.5 0C19.5422 0 25 5.15781 25 12.125C25 19.0922 19.5422 24.25 12.5 24.25C11.2344 24.25 10.0219 24.0828 8.88125 23.7703C8.66008 23.7088 8.42446 23.7253 8.21406 23.8172L5.73281 24.9141C5.58296 24.9802 5.41916 25.0084 5.25581 24.9964C5.09246 24.9844 4.93457 24.9324 4.79601 24.8451C4.65744 24.7578 4.54246 24.6377 4.46115 24.4956C4.37984 24.3534 4.33469 24.1934 4.32969 24.0297L4.26094 21.8062C4.25619 21.6709 4.22396 21.538 4.1662 21.4155C4.10845 21.293 4.02639 21.1835 3.925 21.0938C1.49375 18.9188 0 15.7688 0 12.125ZM8.66562 9.84531L4.99375 15.6703C4.64219 16.2297 5.32812 16.8594 5.85469 16.4609L9.8 13.4672C9.92976 13.3686 10.0881 13.315 10.251 13.3144C10.414 13.3139 10.5727 13.3664 10.7031 13.4641L13.6234 15.6547C13.8306 15.8101 14.0678 15.9208 14.3199 15.98C14.5721 16.0392 14.8337 16.0455 15.0884 15.9985C15.3431 15.9515 15.5853 15.8523 15.7998 15.7071C16.0142 15.5618 16.1962 15.3738 16.3344 15.1547L20.0063 9.32969C20.3594 8.77031 19.6719 8.14062 19.1453 8.53906L15.2 11.5328C15.0702 11.6314 14.9119 11.685 14.749 11.6856C14.586 11.6861 14.4273 11.6336 14.2969 11.5359L11.3766 9.34375C11.1694 9.18837 10.9322 9.0776 10.6801 9.01842C10.4279 8.95924 10.1663 8.95294 9.91157 8.99992C9.65687 9.04689 9.41467 9.14613 9.20023 9.29136C8.98579 9.43659 8.80376 9.62467 8.66562 9.84375V9.84531Z",
    fill: "#142C53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_4917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessanger);
export default __webpack_public_path__ + "static/media/messanger.a37ed38bf08bfc9c771946f0bee012a3.svg";
export { ForwardRef as ReactComponent };